import script from "./DuelingImages.vue?vue&type=script&lang=js&setup=true"
export * from "./DuelingImages.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__